// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import tr from './locales/tr_locale.json';
import en from './locales/en_locale.json';

i18n
  .use(LanguageDetector) // cihaz dilini otomatik algılar
  .use(initReactI18next)
  .init({
    fallbackLng: "tr", // algılanamazsa varsayılan dil
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
  });

export default i18n;
